import { Center, VStack, Box, Icon, Heading } from '@chakra-ui/react'
import type { ReactElement } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import NotAllowedGraphic from '../../../../graphics/media-library/NotAllowedGraphic'

const AccessDeniedView = ({minHeight}: {minHeight?: string}): ReactElement => {
  const { t } = useTranslation()

  return (
    <Center height="100%" width="100%" minHeight={minHeight}>
      <VStack spacing={8}>
        <Icon
          as={NotAllowedGraphic}
          width="260px"
          height="200px"
          color="appClearBlue"
        />
        <VStack spacing={2} width="100%">
          <Trans t={t} i18nKey="access_denied">
            <Heading as="h4" fontSize="md" color="appBattleshipGrey">
              Access Denied
            </Heading>
            <Heading
              as="h6"
              fontSize="1em"
              fontWeight="semibold"
              color="appBattleshipGrey"
            >
              You are not authorised to view this asset
            </Heading>
          </Trans>
        </VStack>
      </VStack>
    </Center>
  )
}

export default AccessDeniedView
